//import React from 'react';
//import logo from './logo.svg';
import './App.css';
//import Container from 'react-bootstrap/Container';
import Navigator from './components/Navigator'

const App = () => (
  <div className="App" >
    <Navigator></Navigator>

  </div>
)

export default App;
